import { render, staticRenderFns } from "./FooterFixed.vue?vue&type=template&id=6b04064f&scoped=true"
import script from "./FooterFixed.vue?vue&type=script&lang=js"
export * from "./FooterFixed.vue?vue&type=script&lang=js"
import style0 from "./FooterFixed.vue?vue&type=style&index=0&id=6b04064f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b04064f",
  null
  
)

export default component.exports